import { useEffect, useState } from "react";
import PropTypes from "prop-types";

import {
    CurrentStatus,
    InfoContainer,
    InfoTitle,
    InfoContent,
    OpeningHoursRow,
    Day,
    Time,
    Skeleton
} from "./StoreInformation.styled";

function StoreInformation({ activeItem, placesService }) {
    const [placeDetails, setPlaceDetails] = useState(null);
    const formattedAddress = placeDetails?.formatted_address;
    const openingHours = placeDetails?.opening_hours;

    useEffect(() => {
        if (!activeItem) {
            return;
        }

        const request = {
            placeId: activeItem
        };

        placesService.getDetails(request, (place, status) => {
            if (
                status === window.google.maps.places.PlacesServiceStatus.OK &&
                place
            ) {
                setPlaceDetails(place);
            }
        });
    }, [activeItem, placesService]);

    if (!placeDetails) return <Skeleton />;

    function getNowOpen() {
        const date = new Date();
        const dateIndex = date.getDay();
        const currentDay = openingHours.periods[dateIndex + 1];
        let status;

        if (openingHours.isOpen()) {
            const time = currentDay?.close?.time;
            if (time) {
                const formattedTime = `${time.substr(0, 2)}:${time.substr(2)}`;
                status = (
                    <CurrentStatus>
                        Vandaag geopend tot {formattedTime}
                    </CurrentStatus>
                );
            }
        } else {
            status = <CurrentStatus closed>Momenteel gesloten</CurrentStatus>;
        }

        return status;
    }

    function parseTimeString(time) {
        return time.replace(/^(\d{2})(\d{2})/, "$1:$2");
    }

    const times = openingHours?.periods?.map(period => {
        const dayNames = [
            "Maandag",
            "Dinsdag",
            "Woensdag",
            "Donderdag",
            "Vrijdag",
            "Zaterdag",
            "Zondag"
        ];

        const dayNumber = period?.open?.day ?? period?.close?.day;
        const name = dayNames[dayNumber];

        const openTime = parseTimeString(period?.open?.time);
        const closeTime = parseTimeString(period?.close?.time);

        return (
            <OpeningHoursRow>
                {name && <Day>{name}</Day>}
                {openTime && closeTime && (
                    <Time>
                        {openTime} - {closeTime}
                    </Time>
                )}
            </OpeningHoursRow>
        );
    });

    const hasTimes = times?.length > 0;

    return (
        <>
            {openingHours && getNowOpen()}
            <InfoContainer>
                <InfoTitle>Adres</InfoTitle>
                <InfoContent>{formattedAddress}</InfoContent>
            </InfoContainer>
            {hasTimes && (
                <InfoContainer>
                    <InfoTitle>Openingstijden</InfoTitle>
                    <InfoContent>{times}</InfoContent>
                </InfoContainer>
            )}
        </>
    );
}

StoreInformation.propTypes = {
    activeItem: PropTypes.string,
    placesService: PropTypes.shape({ getDetails: PropTypes.func }).isRequired
};

StoreInformation.defaultProps = {
    activeItem: null
};

export default StoreInformation;
